import React from 'react';
import useTextByLangAndGender from '../../../hooks/useTextByLangAndGender';

const Text = ({ children, className, elementType = 'p' }) => {
    const genretedTextByLang = useTextByLangAndGender();
    const Element = elementType;

    return (
        <Element className={className}>
            {genretedTextByLang(children)}
        </Element>
    );
};

export default Text;
